import Circle from "@/components/Circle";
import Grid from "@/components/Grid";
import { VIDEO_GUIDE_CONNECTIONS_QUERY } from "@/graphql/knowledgeCenter/webinars";

import ListTemplate from "./ListTemplate";
import VideoGuideCard from "./VideoGuideCard";

export default function VideoGuides() {
  return (
    <ListTemplate
      showFilters={false}
      query={VIDEO_GUIDE_CONNECTIONS_QUERY}
      connectionName="videoGuideConnections"
      objectsPlural="video guides"
      Card={VideoGuideCard}
      pageDescription="Discover our detailed guides designed you help you navigate the platform"
      pageTitle="Video Guides"
      icon={
        <Circle bg="transparent" size={80} border="2px solid black">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M36.3068 18.7479C37.2311 19.2949 37.2311 20.7051 36.3068 21.2521L10.011 36.8161C9.10978 37.3496 8 36.6586 8 35.564L8 4.436C8 3.34142 9.10979 2.65044 10.011 3.18388L36.3068 18.7479Z"
              fill="#1A1A1A"
            />
          </svg>
        </Circle>
      }
      Container={Grid}
      containerProps={{
        gridTemplateColumns: ["repeat(1, 1fr)", "repeat(2, 1fr)", "repeat(3, 1fr)"],
        width: "100%",
        gridColumnGap: 16,
        gridRowGap: 40
      }}
      sortOptions={[
        {
          label: "Title asc",
          value: "title"
        },
        {
          label: "Title desc",
          value: "-title"
        }
      ]}
    />
  );
}
